import { Inject, Injectable } from "@angular/core";
import { LinkInfo, LinkSituation } from "@nms-ng2/app/modules/topology/links/links.model";
import { LinkInfoCircuit } from "../links-step.model";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Converte @see LinkInfo para @see LinkInfoCircuit.
 */
@Injectable({
    providedIn: "root"
})
export class LinkInfoToLinkInfoCircuitConverterService {

    convertLinks(links: Array<LinkInfo>): Array<LinkInfoCircuit> {
        return links.map((link) => this.convertLink(link));
    }

    private convertLink(link: LinkInfo): LinkInfoCircuit {
        return {
            name: link.name,
            aEndResourceId: link.aEndResourceId,
            aEnd: link.aEnd,
            aEndTransmission: link.aEndTransmission,
            aEndPortModel: link.aEndPortModel,
            zEndResourceId: link.zEndResourceId,
            zEnd: link.zEnd,
            zEndTransmission: link.zEndTransmission,
            zEndPortModel: link.zEndPortModel,
            status: link.linkStatus.toString(),
            situation: link.linkSituation.toString(),
            distance: link.distance.toString(),
            attenuation: link.attenuation.toString(),
            description: link.description,
            id: link.id,
            identifier: ""
        }
    }

}
